<template>
  <div class="hero-content">
    <h2 class="page-title">
      <img
        :src="textSeries"
        class="page-title-text"
      >
    </h2>
    <div class="hero">
      <hero-image>
        <template v-slot:images>
          <div class="hero-image">
            <img
              :src="heroImage"
              height="320"
              width="320"
            >
          </div>
        </template>
      </hero-image>
      <hero-name>
        <template v-slot:hero-name>
          <span v-html="hero ? hero.name : ''" />
        </template>
      </hero-name>
      <series-merge-notice
        v-if="hero && hero.isSamePerson"
        class="same_text"
        :hero="hero"
      />
    </div>

    <div class="buttons">
      <button @click="goToHeroesPage">
        <img
          :src="require(`@images/common/${$route.params.lang}/btn_back.png`)"
          height="112"
          width="108"
        >
      </button>
      <button @click="showVoteConfirm" :class="[{'-disable': isVoted || termType !== 1}]">
        <img
          :src="require(`@images/hero/${$route.params.lang}/btn_vote.png`)"
          height="113"
          width="500"
        >
      </button>
    </div>
    <p class="note" v-if="isVoted && currentDay < 7" v-html="$t('text004')" />

    <sns-share share-text="footer.share.cheer" :replace-text="replaceText">
      <img :src="require(`@images/hero/${$route.params.lang}/txt_vote-share.png`)" />
    </sns-share>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Api from '@libraries/api/'
import RequestHero from '@requests/hero'
import ModelModal from '@models/modal'
import { validatelocale } from '@constants'

import HeroImage from '@components/hero/hero-image'
import HeroName from '@components/hero/hero-name'
import SeriesMergeNotice from '@components/global/vote-series-merge-notice'
import SnsShare from '@components/global/sns-share'
import ModalVoteConfirm from '@components/modals/modal-vote-confirm'
import modalNALink from '@components/modals/modal-na-link'

import localeVote from '@locales/vote'

export default {
  name: 'heroes',
  $messages: localeVote,
  components: {
    HeroImage,
    HeroName,
    SeriesMergeNotice,
    SnsShare
  },
  data(){
    return {
      hero: null,
    }
  },
  created() {
    //MEMO: storeで保存しているisVotedのresetTime < 現在時間だったらリロードしてstoreをリセットする
    if (this.resetTime && new Date() > new Date(this.resetTime)) {
      location.reload()
    }
    this.getHero(this.$route.params)
  },
  watch: {
    '$route.params.lang'(){
      this.getHero(this.$route.params)
    }
  },
  computed: {
    ...mapGetters('login', ['isLogin', 'isVoted', 'resetTime']),
    ...mapGetters('menu', ['termType', 'currentDay']),
    replaceText() {
      const params = this.$route.params
      const url = `${location.origin}/${params.lang}/series/${params.seriesId}/heroes/${params.heroId}?hero_id=${params.heroId}`
      return {
        hero_name: this.hero ? this.hero.name : '',
        url: url
      }
    },
    textSeries(){
      if (!this.hero) return
      return require(`@images/series/${this.$route.params.lang}/txt_series-${this.hero.seriesId}.png`)
    },
    heroImage() {
      if (!this.hero) return
      return require(`@images/hero/faces/${this.hero.id}.png`)
    },
    modalVoteConfirm() {
      return new ModelModal({component: ModalVoteConfirm, props: this.hero})
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),
    async getHero(params){
      const cookieCheck = await validatelocale(this.$route.params.lang)
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      if (cookieCheck) {
        Api.call(new RequestHero({ seriesId: params.seriesId, heroId:params.heroId }))
          .then((hero) => {
            this.hero = hero
          })
          .catch(({error}) => {
            throw error
          })
      } else {
        location.reload()
      }
    },
    goToHeroesPage() {
      this.$router.push(`/${this.$route.params.lang}/series/${this.$route.params.seriesId}`)
      window.scrollTo(0, 0)
    },
    showVoteConfirm() {
      if (this.isLogin){
        this.showModal(this.modalVoteConfirm)
      } else {
        this.showModal(new ModelModal({
          component: modalNALink,
          props: {
            isModal: true,
            withoutLogin: this.modalVoteConfirm,
            redirectTo: location.href
          }
        }))
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.hero-content {
  padding: 40px 0 0;
}
.page-title {
  background-image: url(~@images/bg_page-title.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  height: 60px;
  width: 608px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &-text {
    margin-top: -8px;
  }
}
.hero {
  padding: 0 40px 30px;
  margin-top: -60px;
}
.same_text {
  color: $color-red
}
.buttons {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  > * {
    @include tap-event();
  }
  > .-disable {
    opacity: .5;
    pointer-events: none;
  }
}
.note {
  text-align: center;
  margin-bottom: 40px;
}
.sns-share {
  margin-top: 30px;
  background-color: rgba(0, 0, 0, .5);
  padding-bottom: 50px;
}
</style>
